import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";

import AdminLayout from "../layout/AdminLayout";

import Dashboard from "../pages/Dashboard";
import Products from "../pages/Products";
import ProductForm from "../pages/ProductForm";
import Orders from "../pages/Orders";
import OrderDetails from "../pages/OrderDetails";
import Users from "../pages/Users";
import Settings from "../pages/Settings";
import EditProduct from "../pages/EditProduct";
import Messages from "../pages/Messages";

export default function AdminRouter() {
    const { user } = useAuth();

    if (user === null) {
        return <div style={{ padding: 50 }}>Carregando...</div>;
    }

    // 🔥 2. Carregado → valida
    if (user.role !== "admin") {
        return <Navigate to="/auth" replace />;
    }

    return (
        <Routes>
            <Route element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="produtos" element={<Products />} />
                <Route path="/editar-produto/:id" element={<EditProduct />} />
                <Route path="produtos/novo" element={<ProductForm />} />
                <Route path="pedidos" element={<Orders />} />
                <Route path="pedidos/:id" element={<OrderDetails />} />
                <Route path="usuarios" element={<Users />} />
                <Route path="configuracoes" element={<Settings />} />
                <Route path="mensagens" element={<Messages />} />
            </Route>
        </Routes>
    );
}
